import React, { FunctionComponent } from "react";
import { useForm } from "react-hook-form";
import {
    Form,
    FormActions,
    FormAdditionalValidation,
    FormFields,
    FormTextField,
    FormUploadField,
    Stack
} from "sprint-common-web";

import { validatePresetFile } from "../validation/validatePresetFile";
import { useCreateManzanitaPresetForm } from "./useCreateManzanitaPresetForm";

export interface CreateManzanitaPresetFormProps {
    onCancel(): void;
    onSubmit(): void;
}

export interface CreateManzanitaPresetFormInputs {
    name: string;
}

export const CreateManzanitaPresetForm: FunctionComponent<CreateManzanitaPresetFormProps> = (
    props: CreateManzanitaPresetFormProps
) => {
    const { errors, control, formState, reset, handleSubmit } = useForm<CreateManzanitaPresetFormInputs>({
        defaultValues: {
            name: ""
        },
        criteriaMode: "all"
    });

    const { createManzanitaPreset, dropFile, clearFile, isFileDropped, droppedFile } = useCreateManzanitaPresetForm();

    const handleCreateManzanitaPreset = async ({ name }: CreateManzanitaPresetFormInputs) => {
        await createManzanitaPreset({ name });
        props.onSubmit();
        reset();
    };

    const handleCancelButtonClick = () => {
        reset();
        props.onCancel();
    };

    const onDropFile = (presetFile: File) => {
        dropFile(presetFile);
    };

    const onRemoveFile = () => {
        clearFile();
    };

    return (
        <Form onSubmit={handleSubmit(handleCreateManzanitaPreset)}>
            <Stack verticalAlign="space-between">
                <FormFields>
                    <FormTextField
                        label="Name"
                        control={control}
                        name="name"
                        errors={errors}
                        rules={{
                            required: "Name is required field"
                        }}
                    />
                    <FormUploadField
                        droppedFilePath={droppedFile?.name}
                        onDropFile={onDropFile}
                        onRemoveFile={onRemoveFile}
                    />
                    <FormActions
                        onCancel={handleCancelButtonClick}
                        submitDisabled={!isFileDropped}
                        isLoading={formState.isSubmitting}
                    />
                    <FormAdditionalValidation
                        control={control}
                        name="additionalValidation"
                        errors={errors}
                        rules={{ validate: () => validatePresetFile(droppedFile?.name, droppedFile?.size) }}
                    />
                </FormFields>
            </Stack>
        </Form>
    );
};
